import { Pipe, PipeTransform } from '@angular/core';

import { UnidadeNegocioMercado } from '../unidade-negocio-mercado';

@Pipe({
    name: 'unidadeNegocioMercadoSituacaoFilter',
    pure: false
})
export class UnidadeNegocioMercadoSituacaoFilterPipe implements PipeTransform {
    /** Filtra os mercados pela situação informada */
    transform(entities: UnidadeNegocioMercado[], situacao: number = null): UnidadeNegocioMercado[] {
        if (!entities) {
            return [];
        }
        // Retorna os mercados quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.mercado?.situacao === situacao);
    }
}
